import { API_ACTIONS } from '../constants/action.constants';
import { HTTP_CODES, HTTP_CREATED, HTTP_OK, HTTP_UNAUTHORIZED, HTTP_UPDATED } from '../constants/http.constants';
import { logBackIn } from './auth.actions';

export async function apiActionCreator(request, dispatch, success, actions = {}) {
  const response = await request();
  const errorDispatch = () => {
    const customErrorAction = actions[response.status];
    customErrorAction && customErrorAction(response.json);
    actions.all && actions.all(response.json);
    if (!customErrorAction || !actions.all) {
      dispatch({
        type: API_ACTIONS[HTTP_CODES[response.status]],
        json: response.json
      });
    }
  };
  switch (response.status) {
    case HTTP_OK:
    case HTTP_CREATED:
    case HTTP_UPDATED:
      return success(response.json);
    case HTTP_UNAUTHORIZED:
      return logBackIn();
    default:
      return errorDispatch();
  }
}
